export enum AvailabilityEnum {
    IMMEDIATELY = "IMMEDIATELY",
    WITHIN_1_WEEK = "WITHIN_1_WEEK",
    WEEKS_1_2 = "WEEKS_1_2",
    WEEKS_2_3 = "WEEKS_2_3",
    WEEKS_4_MORE = "WEEKS_4_MORE",
    UNKNOWN = "UNKNOWN",
    UNAVAILABLE = "UNAVAILABLE",
}

export enum ExperienceEnum {
    MONTHS_0_6 = "MONTHS_0_6",
    MONTHS_6_YEAR_1 = "MONTHS_6_YEAR_1",
    YEARS_1_2 = "YEARS_1_2",
    YEARS_2_5 = "YEARS_2_5",
    YEARS_5_MORE = "YEARS_5_MORE",
    YEARS_10_MORE = "YEARS_10_MORE",
}

export enum GenderEnum {
    MALE = "MALE",
    FEMALE = "FEMALE",
    OTHER = "OTHER",
}

export enum MaritalStatus {
    SINGLE = "SINGLE",
    MARRIED = "MARRIED",
    DIVORCED = "DIVORCED",
    WIDOWED = "WIDOWED",
}

export enum CurrencyEnum {
    USD = "USD",
    EUR = "EUR",
    BRL = "BRL",
}

export enum DegreeTypeEnum {
    HIGH_SCHOOL = "HIGH_SCHOOL",
    ASSOCIATE = "ASSOCIATE",
    BACHELOR = "BACHELOR",
    LICENTIATE = "LICENTIATE",
    SPECIALIZATION = "SPECIALIZATION",
    POST_GRADUATE = "POST_GRADUATE",
    MASTER = "MASTER",
    DOCTORATE = "DOCTORATE",
    POST_DOCTORATE = "POST_DOCTORATE"
}

export enum ExperienceLevelEnum {
    NONE = "NONE",
    NOVICE = "NOVICE",
    EXPERIENCE = "EXPERIENCE",
    VERY_GOOD = "VERY_GOOD",
    PROEFICIENT = "PROEFICIENT",
}

export enum AreaCodeEnum {
    USA = "+1",
    CANADA = "+1",
    MEXICO = "+52",
    BRAZIL = "+55",
    ARGENTINA = "+54",
    COLOMBIA = "+57",
    CHILE = "+56",
    PERU = "+51",
    VENEZUELA = "+58",
    UK = "+44",
    GERMANY = "+49",
    FRANCE = "+33",
    SPAIN = "+34",
    ITALY = "+39",
    RUSSIA = "+7",
    PORTUGAL = "+351",
    CHINA = "+86",
    INDIA = "+91",
    JAPAN = "+81",
    AUSTRALIA = "+61",
    NEW_ZEALAND = "+64",
    SOUTH_AFRICA = "+27",
    EGYPT = "+20",
    NIGERIA = "+234",
    KENYA = "+254",
    SAUDI_ARABIA = "+966",
    TURKEY = "+90"
}

export enum AdvancedFilterEnum {
    MALE = "MALE",
    FEMALE = "FEMALE",
    TEAM_COUPLE_ONLY = "TEAM_COUPLE_ONLY",
    SAILING = "SAILING",
    MOTOR = "MOTOR",
    COMMERCIAL = "COMMERCIAL",
    CHARTER = "CHARTER",
    B1_B2_VISA = "B1_B2_VISA",
    C1_D_VISA = "C1_D_VISA",
    GREEN_CARD_US_CITIZEN = "GREEN_CARD_US_CITIZEN",
    SCHENGEN_EU_RESIDENT = "SCHENGEN_EU_RESIDENT",
    HOSPITALITY_EXPERIENCE = "HOSPITALITY_EXPERIENCE",
    MICHELIN_EXPERIENCE = "MICHELIN_EXPERIENCE",
    INTRODUCTION_VIDEO = "INTRODUCTION_VIDEO",
    VERIFIED_REFERENCE = "VERIFIED_REFERENCE",
    BACKGROUND_CHECK = "BACKGROUND_CHECK",
    SEA_SERVICE_PROVIDED = "SEA_SERVICE_PROVIDED",
}

export enum LanguageLevelEnum {
    BASIC = "BASIC",
    INTERMEDIATE = "INTERMEDIATE",
    ADVANCED = "ADVANCED",
    FLUENT = "FLUENT",
    NATIVE = "NATIVE"
}

export enum LanguageEnum {
    ENGLISH = "ENGLISH",
    SPANISH = "SPANISH",
    FRENCH = "FRENCH",
    GERMAN = "GERMAN",
    PORTUGUESE = "PORTUGUESE",
    ITALIAN = "ITALIAN",
    JAPANESE = "JAPANESE",
    KOREAN = "KOREAN",
    CHINESE = "CHINESE",
    RUSSIAN = "RUSSIAN",
    HINDI = "HINDI",
    ARABIC = "ARABIC",
    TURKISH = "TURKISH",
    DUTCH = "DUTCH",
    GREEK = "GREEK",
    SWEDISH = "SWEDISH",
    POLISH = "POLISH",
    NORWEGIAN = "NORWEGIAN",
    DANISH = "DANISH",
    FINNISH = "FINNISH",
    HEBREW = "HEBREW",
    THAI = "THAI",
    VIETNAMESE = "VIETNAMESE",
    INDONESIAN = "INDONESIAN",
    UKRAINIAN = "UKRAINIAN",
    PERSIAN = "PERSIAN",
    ROMANIAN = "ROMANIAN",
    CZECH = "CZECH",
    HUNGARIAN = "HUNGARIAN",
    SLOVAK = "SLOVAK",
    MALAY = "MALAY",
    SWAHILI = "SWAHILI",
    FILIPINO = "FILIPINO",
    BULGARIAN = "BULGARIAN",
    SERBIAN = "SERBIAN",
    CROATIAN = "CROATIAN",
    SLOVENIAN = "SLOVENIAN"
}

export enum CountryEnum {
    AFGHANISTAN = "AF",
    SOUTH_AFRICA = "ZA",
    GERMANY = "DE",
    ARGENTINA = "AR",
    AUSTRALIA = "AU",
    BELGIUM = "BE",
    BRAZIL = "BR",
    CANADA = "CA",
    CHILE = "CL",
    CHINA = "CN",
    COLOMBIA = "CO",
    SOUTH_KOREA = "KR",
    DENMARK = "DK",
    EGYPT = "EG",
    UNITED_ARAB_EMIRATES = "AE",
    SPAIN = "ES",
    UNITED_STATES = "US",
    FRANCE = "FR",
    GREECE = "GR",
    INDIA = "IN",
    INDONESIA = "ID",
    IRAN = "IR",
    ISRAEL = "IL",
    ITALY = "IT",
    JAPAN = "JP",
    MEXICO = "MX",
    NIGERIA = "NG",
    NORWAY = "NO",
    NEW_ZEALAND = "NZ",
    NETHERLANDS = "NL",
    PAKISTAN = "PK",
    PERU = "PE",
    POLAND = "PL",
    PORTUGAL = "PT",
    UNITED_KINGDOM = "GB",
    RUSSIA = "RU",
    SWEDEN = "SE",
    SWITZERLAND = "CH",
    THAILAND = "TH",
    TURKEY = "TR",
    UKRAINE = "UA",
    URUGUAY = "UY",
    VENEZUELA = "VE",
    VIETNAM = "VN",
    ZIMBABWE = "ZW"
}
